import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const MScProjectManagement = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160',marginLeft:'50px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Master of Science in Project Management</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The MSc in Project Management at Admas University is designed to equip students with the knowledge, tools, and leadership skills necessary to plan, execute, and manage projects efficiently. The program focuses on real-world project applications across various industries including construction, IT, finance, NGOs, and government sectors.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To develop advanced project management skills aligned with global standards.</li>
          <li>To train professionals who can lead projects from initiation to successful completion.</li>
          <li>To promote analytical and problem-solving skills for complex project scenarios.</li>
          <li>To integrate ethical, sustainable, and risk-aware practices into project execution.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Project Planning and Scheduling</li>
          <li>Project Cost and Financial Management</li>
          <li>Risk Management and Quality Assurance</li>
          <li>Contract and Procurement Management</li>
          <li>Organizational Behavior and Team Leadership</li>
          <li>Project Monitoring and Evaluation</li>
          <li>Research Methods in Project Management</li>
          <li>Strategic Project Management</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Bachelor’s degree from an accredited institution (any relevant field).</li>
          <li>Minimum GPA as per the Ministry of Education or university policy.</li>
          <li>Relevant work experience is preferred but not mandatory.</li>
          <li>Pass the entrance examination administered by Admas University.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates of the MSc in Project Management program are well-positioned for careers in project coordination, program management, consultancy, operations leadership, and executive roles in both public and private sectors. They can work in construction, IT, NGOs, healthcare, finance, education, and government projects.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University for Project Management?</h2>
        <ul>
          <li>Specialized curriculum aligned with international project management standards.</li>
          <li>Experienced faculty and practical project simulations.</li>
          <li>Flexible learning options for professionals (evening/weekend programs).</li>
          <li>Strong industry connections and internship opportunities.</li>
          <li>Focus on leadership, ethical responsibility, and local impact.</li>
        </ul>
      </section>
    </div>
  );
};

export default MScProjectManagement;